<template>
	<div  style='max-width:800px; margin: 0 auto' class="tag-partner">
		<div>
			<div v-if="!orderHasEdenred" @click="openEdenred" class="link-detail link-big-detail">
				<b>{{ $t("components.payment.edenred_link") }}</b>
			</div>
			<div v-if="showCTAEdenred">
				<div v-if="edenredState.authorized && edenredState.estimated && !edenredState.confirmed" class="center">
					<br>

					<img class="edenred-logo" src='https://api.quomi.it/oldimg/TicketRestaurant-Logo-Digital-%281%29.png'>

					<div v-if="edenredTicketEstimated > 0">
						<p>Puoi utilizzare Ticket Restaurant® per un totale di <strong>{{ edenredTicketEstimated | priceFilter }}</strong></p>

						<p>
				            <b>N.B.</b> I buoni pasto Ticket Restaurant® non possono essere rimborsati o convertiti in denaro e non si applicano alle spese di spedizione.
				        </p>
						<CTA
							isWithLoader
							:loading="loadingTicket"
							@click="addTicket()"
		                    :content="`Usa Ticket Restaurant®`"
		                    :size="`small`"
		                />

			    	</div>
			    	<div v-else>
			    		<p>
			    			<strong>
			    				Ops! Importo minimo per utilizzare un buono pasto non raggiunto o saldo non disponibile.
			    			</strong>
			    		</p>

						<flash
			                flash="Aggiungi prodotti alla tua spesa e raggiungi il valore minimo di un buono pasto o accedi all’app Ticket Restaurant® per verificare il saldo del tuo conto Cloud."
			                :state="'error'"
			            />
			    	</div>
				</div>

				<div v-if="loadingEstimate">
					<loading-spin
		                :height='100'
		            />
				</div>

				<flash
					class="mt-5"
	                :flash="flash"
	                :state="'error'"
	            />
			</div>
		</div>

		<div v-if="edenredState.authorized && edenredState.confirmed">
			<div>
				<b>Per quest'ordine pagherai {{ (order.transactions.edenred !== null ? order.transactions.edenred : 0) | priceFilter }} in buoni pasto.</b>
			</div>
			<div @click="deleteTicket" class="link-detail">Annullare richiesta</div>

			<div v-if="loadingDelete">
				<loading-spin
	                :height='100'
	            />
			</div>
			<!--<div @click="logout" class="link-detail">Logout</div>-->
		</div>

		<br>

		<div v-if="orderHasEdenred">
            <b>N.B.</b> I buoni pasto Ticket Restaurant® non possono essere rimborsati o convertiti in denaro e non si applicano alle spese di spedizione. Non sono cumulabili con altre promozioni in corso.
        </div>

		<!--<div v-if="orderHasDiscount">
			Hai dei buoni pasto Ticket Restaurant®? Potrai utilizzarli solo rimuovendo il coupon
		</div>-->

	</div>
</template>

<script>

import { EdenredApi } from '../../api/EdenredApi'
import { prices } from '../../mixins/prices'
import { orderStore } from '../../store/orderStore'
import { Order } from '../../core/Order'
import Flash from '../Parts/Flash'

export default {
	mixins: [
		prices
	],

	components: {
		Flash
	},

	data () {
		return {
			edenredTicketEstimated: null,
			loadingEstimate: false,
			loadingDelete: false,
			showCTAEdenred: false,
			loadingTicket: false,

			flash: null
		}
	},

	computed: {
		user () {
			return this.$root.user
		},

		order () {
			return this.user.order
		},

        edenredState () {
        	return {
        		confirmed: this.orderHasEdenred,
        		estimated: this.edenredTicketEstimated,
        		authorized: this.edenredTicketEstimated || this.orderHasEdenred
        	}
        }
	},

	methods: {
		addTicket () {
			this.flash = ''

			this.loadingTicket = true
			// if (!vars || !vars.code) return
			var token = this.user.order.token
			var em = new EdenredApi()
			return em.addTicket(token)

			.then(response => {
				var user = this.user
                if (user) user.order = response.body.data.resource
    
				this.$root.updateUser(user)

				this.loadingTicket = false
			}).finally(() => {
				this.loadOrder()
			})

			.catch(response => {

				this.loadingTicket = false

				if (response.status === 418) {
					this.flash = 'Errore. Riprova.'
					return
				}

				if (response.status === 400) {
					this.flash = response.body.message
				}
			})
		},

		openEdenred () {
			this.flash = ''

			this.showCTAEdenred = !this.showCTAEdenred
			return this.estimateEdenred()
		},

		authEdenred () {
			this.openWindow()
		},


		logout () {
			this.flash = ''

			var token = this.user.order.token
			var em = new EdenredApi()			
			return em.logout(token)

			.then(response => {
				var user = this.user
                if (user) user.order = response.body.data.resource
    
				this.$root.updateUser(user)

				this.showCTAEdenred = false
			})

			.catch(response => {
				if (response.status === 418) {
					this.flash = 'Errore. Riprova.'
					return
				}
			})
		},

		deleteTicket () {
			this.flash = ''

			if (this.loadingDelete)
				return;

			var token = this.user.order.token
			var em = new EdenredApi()		
			this.loadingDelete = true;


			return em.deleteTicket(token)

			.then(response => {
				var user = this.user
                if (user) user.order = response.body.data.resource
    
				this.$root.updateUser(user)

				this.showCTAEdenred = false
			})

			.catch(response => {
				if (response.status === 418) {
					this.flash = 'Errore. Riprova.'
					return
				}
			})
			.finally(response => {
				this.loadingDelete = false;
				this.loadOrder()
			})
		},

		estimateEdenred () {
			this.flash = ''

			if (this.loadingEstimate) return
			if (this.edenredState.estimated) return 
			this.loadingEstimate = true

			var token = this.user.order.token
			var em = new EdenredApi()			
			return em.estimate(token)

			.then(response => {
				this.edenredTicketEstimated = response.body.data.amount
				this.loadingEstimate = false
			})

			.catch(response => {
				this.loadingEstimate = false

				if (response.status === 418) {
					this.flash = response.body.message ? response.body.message : 'Errore. Riprova.'
					return
				}

				if (response.status === 400) {
					this.authEdenred()
					return
				}
			})
		},

		openWindow () {
			var params = {
				redirect_uri: location.protocol+'//'+location.host + '/oauth/edenred/token',
				client_id: process.env.VUE_APP_EDENRED_OAUTH_CLIENT_ID,
				response_type: 'code',
				scope: 'openid%20edg-xp-mealdelivery-api%20offline_access',
				state: 'abc123',
				nonce: '456azerty',
				acr_values: 'tenant:it-ben',
				ui_locales: 'it-IT'
			}

			window.location = process.env.VUE_APP_EDENRED_URL + `/connect/authorize?response_type=${params.response_type}&client_id=${params.client_id}&scope=${params.scope}&redirect_uri=${params.redirect_uri}&state=${params.state}&nonce=${params.nonce}}&acr_values=${params.acr_values}&ui_locales=${params.ui_locales}`
		},
		
		loadOrder () {
			if (!this.user.order) return 
			orderStore.state.order = new Order(this.user.order)
		},
	},

	mounted () {
		if (this.$route.query.edenred) {
			this.openEdenred()
		}
		
	}
}

</script>

<style scoped>
.btn, .btn:hover {
	margin: 0  auto;
}

.edenred-logo {
	max-width: 210px;
	margin-bottom: 20px;
}
</style>
